<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Ajuda</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Ajuda',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn :disabled="!$check(user, ['help.create'])" id="btnNew" type="button" color="primary"
                                    elevation="0" to="/ajuda/novo" v-on="on" v-bind="attrs">
                                    Incluir
                                </v-btn>
                            </template>
                            <span>Incluir nova ajuda</span>
                        </v-tooltip>
                    </div>
                </div>
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="name" label="Título" v-model="dataList.filter.title"
                                        hide-details outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="filter-card-title">Filtros</v-card-title>
                    <v-form @submit.prevent="load()">
                        <v-divider class="mt-2"></v-divider>

                        <v-container>
                            <v-row class="mt-3">
                                <v-col cols="4" align-self="baseline">
                                    <v-text-field style="padding-left: 8px;" dense label="Procurar"
                                        v-model="dataList.filter.name" hide-details outlined clearable
                                        @click:clear="clearNameSearch">
                                    </v-text-field>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col v-if="hasFilters()" cols="auto" style="padding-right: 1px;">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" id="btnClearFilter" type="button" outlined color="primary"
                                                @click="clearFilters">
                                                Limpar</v-btn>
                                        </template>
                                        <span>Limpar filtros de busca selecionados</span>
                                    </v-tooltip>
                                </v-col>

                                <v-col cols="auto" style="padding-right: 16px;">
                                    <v-tooltip bottom>
                                        <template #activator="{ on, attrs }">
                                            <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2"
                                                v-on="on" v-bind="attrs">
                                                Filtrar
                                            </v-btn>
                                        </template>
                                        <span>Filtrar dados</span>
                                    </v-tooltip>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-form>

                    <v-card-title class="table-card-title">Ajuda</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhuma ajuda foi encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.name`]="{ item }">
                                {{ item.name.toUpperCase() }}
                            </template>

                            <template v-slot:[`item.is_active`]="{ item }">
                                <v-chip small class="text-uppercase font-weight-bold text-caption"
                                    :color="item.is_active === 1 ? 'accent' : 'warning'" label text-color="white">
                                    {{ item.is_active === 1 ? 'SIM' : 'NÃO' }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.category`]="{ item }">
                                <v-chip small class="text-uppercase font-weight-bold text-caption"
                                    :color="getCategoryColor(item.category)" label text-color="white">
                                    {{ getCategoryLabel(item.category) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.priority`]="{ item }">
                                <v-chip small class="text-uppercase font-weight-bold text-caption"
                                    :color="getPriorityColor(item.priority)" label text-color="white">
                                    {{ getPriorityLabel(item.priority) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">

                                    <v-tooltip bottom>
                                        <template #activator="{ on, attrs }">
                                            <v-icon v-on="on" v-bind="attrs" :disabled="!$check(user, ['help.find'])"
                                                @click="viewItem(item)" size="large"
                                                class="me-2">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on, attrs }">
                                            <v-icon v-on="on" v-bind="attrs" :disabled="!$check(user, ['help.delete'])"
                                                @click="deleteItem(item)" size="large" class="me-2">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Excluir</span>
                                    </v-tooltip>

                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import categoryTypes from '@/common/data/help-categories-types.data'

import object from "@/common/util/object"
import eventStatus from "@/common/data/event-status.data";

Vue.use(VueLodash)

export default {
    name: "HelpList",

    data: () => ({
        user: null,
        dataset: {
            data: {},
            priorityTypes: [{ id: 1, name: 'Alta' }, {id: 2, name: 'Média'}, {id: 3, name: 'Baixa'}],
            isActiveTypes: [{ id: 1, name: "SIM" }, { id: 2, name: "NÃO" }],
            categoryTypes: categoryTypes,
        },
        dataList: {
            filter: {
                name: "",
            },
            headers: [
                { text: "Título", value: "name" },
               // { text: "Link", value: "link" },
                { text: "Categoria", value: "category" },
                { text: "Prioridade", value: "priority" },
                { text: "Ativo", value: "is_active" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        hasFilters() {
            return Object.values(this.dataList.filter).some(value => value !== "");
        },

        async clearFilters() {
            Object.keys(this.dataList.filter).forEach(key => {
                this.dataList.filter[key] = "";
            });
            await this.load();
        },

        clearNameSearch() {
            this.dataList.filter.content = "";
            this.load();
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {
            this.user = this.$root.user.data || this.$root.user;
            console.log("USER: ", this.user)

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            //search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            //var limit = this.dataList.options.itemsPerPage;

            const params = { 
                page: this.dataList.options.page, 
                limit: this.dataList.options.itemsPerPage,
                search: !object.isEmpty(search) ? JSON.stringify(search) : "{}"
            } 

            try {
                const result = await axios.get('/api/helps', { params });

                console.log("Dados: ", result)

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                })
            } finally {
                this.dataList.loading = false;
            }

        },

        viewItem(item) {
            this.$router.push(`ajuda/${item.id}`);
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir Ajuda',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`/api/admin/helps/${item.id}`)

                this.$dialog.notify.info("Ajuda excluída com sucesso!", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }
        },

        getPriorityColor(type) {
            switch (type) {
                case 1:
                    return '#E53935';
                case 2:
                    return '#FF6D00';
                case 3:
                    return '#AED581';
                default:
                    return 'grey';
            }
        },

        getPriorityLabel(priority) {
            return (this.dataset.priorityTypes.find(x => x.id === priority) || {}).name || 'N/A';
        },

        getCategoryColor(category) {

            console.log("Category: ", category)

            switch (category) {
                case 1:
                    return '#03A9F4';
                case 2:
                    return '#00BCD4';
                case 3:
                    return '#5C6BC0';
                default:
                    return 'grey';
            }
        },

        getCategoryLabel(category) {
            return (this.dataset.categoryTypes.find(x => x.id === category) || {}).name || 'N/A';
        },
    },
};
</script>